import React from 'react';
import PropTypes from 'prop-types';
import * as styles from '../../../../../features/AdministrationPortal/AdviserProfileApprovalEditor/AdviserProfile/_AdviserProfile.scss'
import SubmitButton from '../../../../../common/forms/SubmitButton'
import SubmitSpinner from '../../../../../common/Spinners/SubmitSpinner'
import SuccessCheckMessage from '../../../../../common/SuccessCheckMessage'
import { Alert } from 'react-bootstrap'
import { approveProfile } from './adviserProfilePromoteToApprovedActions'
import { connect } from 'react-redux'

const AdviserProfilePromoteToApproved = function ({
    profile
    , approveProfile
    , dispatch
    , edited
    , submitting
    , submitted
    , isSubmitting
    , disabled
    , readyForApproval
    , invalidArray
    , rejectButton
  }) {
  const adviserId = profile.adviserId
  const message = 'Profile approved.'
  return <div>
    {!readyForApproval && invalidArray && invalidArray.length > 0 &&
      <Alert variant='warning'>
        <p>This profile can't be approved yet - the following mandatory fields still need to be completed:</p>
        <ul>
          {invalidArray.map((invalidItem, index) => <li key={index}>{invalidItem}</li>)}
        </ul>
      </Alert>}
    <div className={styles['approval-actions']}>
      <SubmitButton buttonText={'Approve Profile'} isValid={readyForApproval} isSubmitting={isSubmitting || disabled} onClick={() => dispatch(approveProfile(adviserId))} />
      {/* Spinner sits in the button row so it lines up with the buttons, not in the centred row below. */}
      {(isSubmitting || submitting) && <SubmitSpinner />}
      {rejectButton}
    </div>
    <div className={styles['row'] + ' ' + styles['top-padding']}>
      {submitted && !edited && <SuccessCheckMessage message={message} />}
    </div>
  </div>
}

AdviserProfilePromoteToApproved.propTypes = {
  profile: PropTypes.object.isRequired,
  approveProfile: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  edited: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  submitted: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool,
  disabled: PropTypes.bool,
  readyForApproval: PropTypes.bool,
  invalidArray: PropTypes.array,
  rejectButton: PropTypes.node
}

const mapStateToProps = ({ adviserProfileApprovalEditorContainer }) => {
  return {
    edited: adviserProfileApprovalEditorContainer.edited,
    submitting: adviserProfileApprovalEditorContainer.promoteToApproved.submitting,
    submitted: adviserProfileApprovalEditorContainer.promoteToApproved.submitted,
    disabled: adviserProfileApprovalEditorContainer.promoteToApproved.disabled,
    readyForApproval: adviserProfileApprovalEditorContainer.readyForApproval,
    invalidArray: adviserProfileApprovalEditorContainer.invalidArray
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch,
    approveProfile: approveProfile
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdviserProfilePromoteToApproved)
